export function padZeroes(num: number, size): string {
  var s = String(num);
  while (s.length < size) s = '0' + s;
  return s;
}
